import styled from 'styled-components'

import { header } from '../../../styles/z-index'
import { maxmedia, minmedia } from '../../../styles/media-queries'
import { white, bordergray } from '../../../styles/colors'

export const OuterWrap = styled.div`
  transition: all .3s ease-in-out;
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 1920px;
  transform: translateY(-100%);
  z-index: ${header};

  &.active {
    transform: translateY(0);
  }

  ${maxmedia.xmlarge`
    display: none;
  `}
`

export const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${bordergray};
  box-shadow: 0 1px 3px -3px rgba(0, 0, 0, 0.2);
  background: ${white};
`

export const LogoContainer = styled.div`
  padding-left: calc(4% + 45px); // match container + center of big logo
  width: 200px;
`

export const PageNavContainer = styled.div`
  flex-grow: 1; //fill remaining width
  padding-left: 1.5rem;

  ${minmedia.xxlarge`
    padding-left: 3rem;
  `}
`

export const IconNavContainer = styled.div`
  width: 270px; // 9x3
`

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
`


// WEBPACK FOOTER //
// ./src/components/Header/StickyHeader/styles.js